import { Formik } from 'formik'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import {
  useCandidateDetailsById,
  useCandidatePositionDetailsById,
  usePositions
} from 'src/queries'
import { MutateCopyCandidateMutation } from 'src/gql/graphql'
import { useMutateCopyCandidate, UseMutateCopyCandidateReturn } from 'src/queries/cat/candidate/useMutateCopyCandidate'
import Form from './Form'

type Values = Parameters<UseMutateCopyCandidateReturn['mutate']>[0]

interface FormContextProps {
  id: string
  toggle: () => void
}

interface FormValues {
  position: string | undefined
  distribution: string | undefined
  name: {
    first: string
    last: string
  }
  details?: boolean
  contact?: boolean
  rates?: boolean
  notes?: boolean
  attachments?: boolean
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  console.log(id)
  const navigate = useNavigate()
  const candidate = useCandidateDetailsById(id)
  const positionDetails = useCandidatePositionDetailsById(id)
  if (candidate === undefined) {
    throw new Error('Could not load candidate!')
  }
  const positions = usePositions()
  const lookups = {
    positions: positions.map(p => ({ value: p._id, label: `[${p._contract?.abbreviation ?? ''}] ${p.id ?? 'Unknown'} - ${p.title ?? 'Unknown'}` }))
  }
  const copy = useMutateCopyCandidate()
  const { name } = candidate
  const initialState: FormValues = {
    name: {
      first: name?.first ?? '',
      last: name?.last ?? ''
    },
    position: String(positionDetails?._position?._id),
    distribution: positionDetails?._distribution?._id,
    details: true,
    contact: true,
    rates: true,
    notes: true
  }
  const handleSuccess = (data: MutateCopyCandidateMutation): void => {
    const id = data.cat?.candidate?.copy?.recordId
    if (id !== undefined) {
      toggle()
      navigate(`/cat/candidates/${String(id)}`)
    } else {
      throw new Error('There was an issue getting the candidate\'s ID.')
    }
  }
  const validationSchema = Yup.object().shape({
    name: Yup.object().shape({
      first: Yup.string().required().label('First Name'),
      last: Yup.string().required().label('Last Name')
    }),
    position: Yup.number().required().label('Position'),
    distribution: Yup.string().required().label('Distribution')
  })
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        if (data.position === undefined) {
          throw new Error('Invalid position value format.')
        }
        console.log(data)
        const record: Values = {
          id,
          position: parseInt(data.position),
          distribution: data.distribution === '' ? null : data.distribution,
          name: {
            first: data.name.first,
            last: data.name.last
          },
          details: data.details ?? false,
          contact: data.contact ?? false,
          rates: data.rates ?? false,
          notes: data.notes ?? false,
          attachments: data.attachments ?? false
        }
        copy.mutate(record, { onSuccess: handleSuccess })
      }}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form
          lookups={lookups}
          toggle={toggle}
          isLoading={copy.isLoading}
          hasError={copy.isError}
        />
      )}
    </Formik>
  )
}

export default FormContext
